var React = require('react');

function LampFloor (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36 8H60L72 36H24L36 8Z","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M48 36V88","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M36 88H60","stroke":"black","strokeWidth":"8","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

LampFloor.defaultProps = {"width":"96","height":"96","viewBox":"0 0 96 96","fill":"none"};

module.exports = LampFloor;

LampFloor.default = LampFloor;
